var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-progress-linear", {
    attrs: {
      color: "accent",
      height: 4,
      active: _vm.show,
      query: true,
      role: "progressbar",
      "aria-label": "Page loading progress",
      "aria-valuenow": _vm.loadingPercent,
      "aria-valuemin": "0",
      "aria-valuemax": "100",
    },
    model: {
      value: _vm.loadingPercent,
      callback: function ($$v) {
        _vm.loadingPercent = $$v
      },
      expression: "loadingPercent",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }